import { useMemo } from "react";
import { withHostelData, type PartnerMapData } from "../partners/madmonkey/hostelProgram";
import { withLiveList } from "../partners/maps/liveHighlights";
import PartnerMap from "../partners/maps/PartnerMap";
import { getPartnerMap } from "../partners/maps/registry";
import NotFound from "./NotFound";

interface PartnerMapPageProps {
	match: { params: { partner?: string } };
	/** the partner's synced list, read by the server (loader `partnerMap`), and for a Mad Monkey hostel's map its program; null until either exists */
	initialData?: PartnerMapData | null;
}

/**
 * `/p/:partner`: a partner's map page, such as The Urban Jungle Hostel's. One page for every partner: the content
 * file of the slug (`partners/maps/<slug>.json`) is all there is to it, with the partner's synced Stippl list laid over
 * its highlights once that list exists (`liveHighlights.ts`). A Mad Monkey hostel's map (`/p/mad-monkey-<hostel>`) has no
 * file: it is made from the hostel's data, and its program is laid over it too (`hostelProgram.ts`). A page is in one language, the
 * content file's `lang` (English unless it says Dutch, `/p/indewaag-nl`: a slug of its own, not a language prefix). Noindex,
 * in no sitemap and linked from nowhere on the site. A slug that names nothing renders the site's own not-found page (the
 * server answers it with a 404, see `knownParams` in marketingRoutes.tsx).
 */
const PartnerMapPage = ({ match, initialData }: PartnerMapPageProps) => {
	const file = getPartnerMap(match.params.partner ?? "");
	const content = useMemo(() => file && withHostelData(withLiveList(file, initialData), initialData), [file, initialData]);
	return content ? <PartnerMap content={content} /> : <NotFound />;
};

export default PartnerMapPage;
